<div class="dialog-container map-dialog-shell">
  <div class="dialog-header">
    <div class="dialog-icon">📍</div>
    <div class="dialog-heading">
      <h2 class="dialog-title">Choisir un lieu sur la carte</h2>
      <p class="dialog-subtitle">Sélectionnez un point précis pour la récupération ou la livraison</p>
    </div>
    <button type="button" class="btn-icon" (click)="closeMap()" aria-label="Fermer">✕</button>
  </div>

  <mat-dialog-content class="dialog-content">
    <div class="map-instructions">
      <p>Cliquez sur la carte ou déplacez le marqueur pour choisir l’emplacement.</p>
      <div class="map-tools">
        <button type="button" class="btn btn-locate" (click)="locateMe()" [disabled]="geolocating">
          {{ geolocating ? 'Localisation...' : 'Me localiser' }}
        </button>
        <span class="coord-badge">{{ coordinatesLabel }}</span>
      </div>
    </div>
    <p *ngIf="geolocationMessage" class="geo-feedback">{{ geolocationMessage }}</p>
    <div id="mapid" class="map-panel"></div>
  </mat-dialog-content>

  <div class="dialog-actions">
    <div class="selection-state">
      <span class="selection-dot"></span>
      <span>{{ coordinatesLabel }}</span>
    </div>
    <button type="button" class="btn btn-secondary" (click)="closeMap()">Annuler</button>
    <button type="button" class="btn btn-primary" (click)="validate()">Valider l'emplacement</button>
  </div>
</div>
